import React from "react";
import { Sparkles, Bot, Scale, ShieldAlert, Ban } from "lucide-react";
import { LegalPage } from "../components/LegalPage";

export const TerminosIAPage = () => {
  const sections = [
    {
      id: "1",
      icon: Bot,
      title: "1. Naturaleza del Servicio",
      body:
        'OptiShield IA es una herramienta de inteligencia artificial proporcionada "tal cual". Aunque está optimizada para ofrecer asistencia sobre los servicios de OptiShield X, no reemplaza el juicio de un profesional técnico humano.',
    },
    {
      id: "2",
      icon: ShieldAlert,
      tag: "Importante",
      title: "2. Exactitud de la Información",
      body:
        'Debido a la naturaleza del aprendizaje automático, OptiShield IA puede generar en ocasiones información incorrecta, incompleta o desactualizada (fenómeno conocido como "alucinación"). El usuario acepta verificar cualquier comando crítico, script o configuración de servidor antes de ejecutarlo en su infraestructura.',
    },
    {
      id: "3",
      icon: Ban,
      title: "3. Uso Aceptable",
      body: "Al interactuar con OptiShield IA, aceptás NO utilizarla para:",
      bullets: [
        "Generar contenido ilegal, malicioso, difamatorio o discriminatorio.",
        "Solicitar o intentar generar código para vulnerar sistemas (hacking malicioso, DDoS, exploits).",
        'Intentar eludir los filtros de seguridad del bot ("jailbreaking").',
      ],
    },
    {
      id: "4",
      icon: Scale,
      title: "4. Limitación de Responsabilidad",
      body:
        "OptiShield X no se hace responsable por pérdida de datos, caídas de servidores o daños a la infraestructura derivados de seguir directamente los consejos o comandos proporcionados por OptiShield IA.",
    },
  ];

  return (
    <LegalPage
      title="Términos - OptiShield IA | OptiShield X"
      breadcrumb={[
        { label: "Inicio", to: "/" },
        { label: "OptiShield IA", to: "/ia" },
        { label: "Términos de Uso" },
      ]}
      tag={{ icon: Sparkles, label: "Términos de OptiShield IA" }}
      headline={{ prefix: "Términos de", accent: "OptiShield IA" }}
      subtitle="Reglas de uso de nuestro asistente inteligente basado en IA. Al usarlo aceptas estos términos."
      lastUpdated="Febrero 2026"
      sections={sections}
      ctaTitle="¿Dudas sobre OptiShield IA?"
      ctaDescription="Podés probarla gratis en nuestro Discord oficial."
      ctaLinks={[
        { label: "Privacidad IA", to: "/privacidad-ia", testId: "terminos-ia-privacidad-link" },
        { label: "Ir a OptiShield IA", to: "/ia", testId: "terminos-ia-back-link" },
        { label: "Discord", href: "https://discord.gg/ExE6pGa4df", primary: true, testId: "terminos-ia-discord-link" },
      ]}
      testIdPrefix="terminos-ia"
    />
  );
};
